import React from 'react'
import { Box, TextField, InputAdornment, Stack } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

export interface PageToolbarProps {
  searchTerm?: string
  onSearchChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  searchPlaceholder?: string
  hideSearch?: boolean
  actionButtons?: React.ReactNode
  children?: React.ReactNode
}

const PageToolbar: React.FC<PageToolbarProps> = ({
  searchTerm,
  onSearchChange,
  searchPlaceholder = 'Search...',
  hideSearch = false,
  actionButtons,
  children
}) => {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={2}
      sx={{
        alignItems: { xs: 'stretch', md: 'center' },
        justifyContent: 'space-between',
        mb: 3
      }}
    >
      {/* LEFT SIDE */}
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        sx={{ width: '100%', maxWidth: { md: '75%' } }}
      >
        {!hideSearch && (
          <TextField
            placeholder={searchPlaceholder}
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={onSearchChange}
            sx={{ minWidth: { xs: '100%', sm: 250 } }}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                )
              }
            }}
          />
        )}
        {children}
      </Stack>

      {/* RIGHT SIDE */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: { xs: 'flex-start', md: 'flex-end' },
          minWidth: 'fit-content'
        }}
      >
        {actionButtons}
      </Box>
    </Stack>
  )
}

export default PageToolbar
